import { apiWrapper } from "@/services/api";

// 2022.4までのサンリオ用 終売後削除予定
export const getQrLink = async (id) => {
  try {
    const resp = await apiWrapper("GET", `passes/${id}/qrcode`);
    return resp.data;
  } catch (err) {
    console.log("ERROR!!! getQrLink");
    throw err;
  }
};
